var defaultMakePropertyPrefix = function defaultMakePropertyPrefix(prefix, property) {
  return "".concat(prefix, "__").concat(property);
};

export default defaultMakePropertyPrefix;